/* esm.sh - @lit/reactive-element@1.6.3/decorators/query-assigned-elements */
import{decorateProperty as a}from"./base.mjs";var r,u=((r=window.HTMLSlotElement)===null||r===void 0?void 0:r.prototype.assignedElements)!=null?(e,o)=>e.assignedElements(o):(e,o)=>e.assignedNodes(o).filter((t=>t.nodeType===Node.ELEMENT_NODE));function E(e){let{slot:o,selector:t}=e??{};return a({descriptor:c=>({get(){var n;let i="slot"+(o?`[name=${o}]`:":not([name])"),l=(n=this.renderRoot)===null||n===void 0?void 0:n.querySelector(i),s=l!=null?u(l,e):[];return t?s.filter((d=>d.matches(t))):s},enumerable:!0,configurable:!0})})}export{E as queryAssignedElements};
/*! Bundled license information:

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=query-assigned-elements.mjs.map